export default {
	sec_01: {
		title: {
			one: '자주 가는 매장에서 결제하세요.',
			two: '',
			three: 'JP WOLRD Pay로',
		},
		desc: {
			one: '직접 결제하는 것은 결제시 QR코드를',
			two: '스캔하는 것 만큼 쉽고 터치가 필요 없습니다.',
			three: '카드나 현금을 취급 할 필요가 없으며 앱을 사용하기만 하면 됩니다.',
		},
		btn: {
			one: '회원가입하기',
			two: '로그인',
		},
	},
	sec_04: {
		title: '미래화폐 시스템에 오신 것을 환영합니다.',
		cards: {
			one: {
				title: '안전한 결제',
				description: {
					one: '오프라인 결제 시',
					two: '고객님의 정보가 남지 않습니다.',
				},
			},
			two: {
				title: '가까운 가맹점에서',
				description: {
					one: '언제 어디서나 JP WOLRD Pay가',
					two: '가맹 된 곳을 찾아 사용하세요.',
				},
			},
			three: {
				title: '현금없이',
				description: {
					one: '아직도 현금을 들고 다니시나요?',
					two: '휴대폰에서 JP WOLRD Pay를 바로 사용하세요.',
				},
			},
		},
	},
	sec_06: {
		title: {
			one: 'QR로 3단계 결제',
			two: '자노페이어플과 계정이 필요합니다.',
			three: '',
		},
		step: {
			one: {
				title: 'STEP 01.',
				subTitle: '스캔 또는 표시',
				desc: {
					one: 'QR 아이콘을 탭하고 판매자가 코드를 제시하면 스캔을 선택하거',
					two: '나 QR코드를 요청하는 경우 지불하기 위해 표시를 탭하십시오.',
				},
			},
			two: {
				title: 'STEP 02.',
				subTitle: '지불',
				desc: {
					one: 'QR 코드가 표시되면 코드 스캔',
					two: '',
				},
			},
			three: {
				title: 'STEP 03.',
				subTitle: '확인',
				desc: {
					one: '결제 확인을 수신하면 모든 결제가 완료됩니다.',
					two: '',
				},
			},
		},
	},
	sec_07: {
		title: {
			one: 'QR 코드로',
			two: '판매를 준비하세요.',
		},
		desc: {
			one: '사업을 시작하든 운영하든, 하드웨어, 소프트웨어',
			two: '또는 카드 리더 없이도 터치가 필요없는 대면 결제를',
			three: '쉽게 수락 할 수 있습니다.',
		},
	},
};
